import { render, staticRenderFns } from "./ActionButtons.vue?vue&type=template&id=6caa406c&scoped=true"
import script from "./ActionButtons.vue?vue&type=script&setup=true&lang=ts"
export * from "./ActionButtons.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ActionButtons.vue?vue&type=style&index=0&id=6caa406c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6caa406c",
  null
  
)

export default component.exports